import axios, { AxiosResponse } from "axios";

import {
  ContainerType,
  CommonTypes,
  RegistryTypes,
  PackageType,
  SamskipAPIResponse,
} from "@assets/types";

const SamskipAPI = process.env.SamskipAPI;

class RegistryService {
  getContainerTypes = async () => {
    const res: AxiosResponse<SamskipAPIResponse<ContainerType[]>> =
      await axios.get(`${SamskipAPI}/Registry/containertypes`);
    return res.data.ReturnItem.Data;
  };

  getPackageTypes = async () => {
    const res: AxiosResponse<SamskipAPIResponse<PackageType[]>> =
      await axios.get(`${SamskipAPI}/Registry/packagetypes`);
    return res.data.ReturnItem.Data;
  };

  getIncoterms = async () => {
    const res: AxiosResponse<SamskipAPIResponse<RegistryTypes.Incoterm[]>> =
      await axios.get(`${SamskipAPI}/Registry/incoterms`);
    return res.data.ReturnItem.Data;
  };

  getPostCodeRegex = async (countryCode: string) => {
    const res: AxiosResponse<SamskipAPIResponse<string>> = await axios.get(
      `${SamskipAPI}/Registry/postcode-regex`,
      {
        params: { countryCode },
      }
    );
    return res.data.ReturnItem.Data;
  };

  searchCountries = async (searchString: string) => {
    const res: AxiosResponse<SamskipAPIResponse<CommonTypes.Country[]>> =
      await axios.get(`${SamskipAPI}/Registry/countries/search`, {
        params: {
          searchString: searchString,
        },
      });
    return res.data.ReturnItem.Data;
  };

  getAllCountries = async () => {
    const res: AxiosResponse<SamskipAPIResponse<CommonTypes.Country[]>> =
      await axios.get(`${SamskipAPI}/Registry/countries`);
    return res.data.ReturnItem.Data;
  };

  getCountry = async (countryCode: string) => {
    const res: AxiosResponse<SamskipAPIResponse<CommonTypes.Country>> =
      await axios.get(
        `${SamskipAPI}/Registry/countries/${encodeURIComponent(countryCode)}`
      );
    return res.data.ReturnItem.Data;
  };

  getHSCodes = async () => {
    const res: AxiosResponse<SamskipAPIResponse<CommonTypes.HSCode[]>> =
      await axios.get(`${SamskipAPI}/Commodities/tariff/hsCodes`);
    return res.data.ReturnItem.Data;
  };

  searchHSCodes = async (searchString: string) => {
    const res: AxiosResponse<SamskipAPIResponse<CommonTypes.HSCode[]>> =
      await axios.get(
        `${SamskipAPI}/Commodities/tariff/filter/${encodeURIComponent(
          searchString
        )}`
      );
    return res.data.ReturnItem.Data;
  };
}

export default new RegistryService();
